/** Today as YYYY-MM-DD. */
export function todayIso() {
    return new Date().toISOString().slice(0, 10);
}
/** Format a number as "KES 1,234,567". */
export function formatKes(amount) {
    return `KES ${Math.round(amount).toLocaleString("en-KE")}`;
}
